/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { NodeE2EPage } from '@/pages/NodeE2E/NodeE2EPage';

export function NodeE2ERoute() {
  return <NodeE2EPage />;
}
